import { CLEAR_USER_INFO, SET_USER_INFO } from '../constants/user';
import { IUserInfo } from '../reducers/user';

export const setUserInfo = (data: IUserInfo) => {
  return {
    type: SET_USER_INFO,
    payload: data,
  };
};

export const clearUserInfo = () => {
  return {
    type: CLEAR_USER_INFO,
    payload: {},
  };
};
